import React, { useState } from "react";

import LoanRequest from "./LoanRequest";

const LoanHome = () => {
  return (
    <div className="flex justify-between  bg-gray-100">
      {/* Left Side */}
      <div className="bg-white p-5 rounded-lg shadow-md w-1/3">
        <h2 className="text-xl font-semibold mb-4">Outstanding Balance</h2>
        <p className="text-2xl text-red-600">-N1,250,000</p>
        <p className="text-lg">
          Available balance: <strong>N850,000</strong>
        </p>

        <button className="w-full py-2  bg-gray-500 text-white rounded hover:bg-gray-700 mt-3">
          Deposit
        </button>
        <button className="w-full py-2 bg-gray-500 text-white rounded hover:bg-gray-700 mt-3">
          Withdraw
        </button>
      </div>

      {/* Right Side */}
      <LoanRequest />
    </div>
  );
};

export default LoanHome;
